"use client";

import { useId, type ReactElement, type SVGProps } from "react";

export function PreviewLoadingStarIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  const id = `preview-loading-gold-${useId().replace(/:/g, "")}`;
  return (
    <svg
      className="animate-preview-breathe [transform-origin:center] motion-reduce:animate-none"
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      {...props}
    >
      <path
        d="M12 2 L14.6 9.4 L22 12 L14.6 14.6 L12 22 L9.4 14.6 L2 12 L9.4 9.4 Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient id={id} x1="4" y1="4" x2="20" y2="20">
          <stop stopColor="var(--gold-molten-hi)" />
          <stop offset="1" stopColor="var(--gold-molten-lo)" />
        </linearGradient>
      </defs>
    </svg>
  );
}
